"use client";

import { useAtom } from "jotai";
import { useCallback } from "react";
import { savedPractitionerIdsAtom } from "./atoms";

/** Read and mutate the saved-practitioner id list. `toggle` is what the card's heart button calls;
 *  `isSaved` is what it renders from. */
export const useSavedPractitioners = () => {
  const [ids, setIds] = useAtom(savedPractitionerIdsAtom);

  const isSaved = useCallback((id: string) => ids.includes(id), [ids]);

  const toggle = useCallback(
    (id: string) => {
      setIds((current) => (current.includes(id) ? current.filter((saved) => saved !== id) : [...current, id]));
    },
    [setIds],
  );

  return { ids, isSaved, toggle };
};
